
const InfiniteScroll = require('infinite-scroll');

class infiniteModule
{
    static run () {

        if( null !== document.querySelector('.pagination__next') ) {
            window.post_loader = new InfiniteScroll( document.querySelector('[data-infinity]'), {
                path: '.pagination__next',
                append: '.article',
                status: '.page-load-status',
                history: false,
            });
        }

    }
}

export default infiniteModule;
